
import { TOKEN_KEY, OSS_HOST} from '@/util/variable'
import {cloneDeep, isArray} from "lodash";
import { ref } from 'vue';
import { getCosAuthorization } from '@/api/service';

// COS 临时授权参数字符串（响应式，便于模板中直接使用）
const cosAuthQuery = ref('');
let cosAuthRefreshTimer = null;

// 刷新 COS 临时授权
async function refreshCosAuth() {
  try {
    const res = await getCosAuthorization();
    if (res.code === 0 && res.data) {
      const auth = res.data;
      cosAuthQuery.value =
        `tmpSecretId=${encodeURIComponent(auth.tmpSecretId)}` +
        `&tmpSecretKey=${encodeURIComponent(auth.tmpSecretKey)}` +
        `&sessionToken=${encodeURIComponent(auth.sessionToken)}` +
        `&startTime=${auth.startTime}` +
        `&expiredTime=${auth.expiredTime}`;
      // 提前 60 秒刷新
      const duration = (auth.expiredTime - auth.startTime - 60) * 1000;
      if (duration > 0) {
        clearTimeout(cosAuthRefreshTimer);
        cosAuthRefreshTimer = setTimeout(refreshCosAuth, duration);
      }
    }
  } catch (e) {
    console.warn('刷新COS授权失败', e);
    // 失败后 30 秒重试
    clearTimeout(cosAuthRefreshTimer);
    cosAuthRefreshTimer = setTimeout(refreshCosAuth, 30 * 1000);
  }
}

// 初始化 COS 授权（在应用入口调用一次即可）
export function initCosAuth() {
  if (cosAuthRefreshTimer) return;
  refreshCosAuth();
}

export const getImageUrl = (previewUrl, isAddAuth = true) => {
  if (!previewUrl) {
    return "";
  }
  const url = previewUrl.startsWith("http") ? previewUrl : `https://${OSS_HOST}/${previewUrl}`;
  // 只对 COS 域名的 URL 拼接授权参数
  const isCosUrl = url.includes(OSS_HOST);
  if (isCosUrl && cosAuthQuery.value && isAddAuth) {
    const separator = url.includes('?') ? '&' : '?';
    return url + separator + cosAuthQuery.value;
  }
  return url;
};

// 金额转换为分
export const priceToCentFormat = (price) => {
  return price*100;
}
// 分转换为元
export const centToPriceFormat = (val) => {
  if ((isNaN(val)||!val)&&val!=0) {
    return '-'
  };
  return '¥'+val/100;
}
export const centToPriceFormatV2 = (val) => {
  if ((isNaN(val)||!val)&&val!=0) {
    return ''
  };
  return val/100;
}


export const LocalStore = {
  set(key, data) {
    localStorage.setItem(key, typeof data === 'string' ? data : JSON.stringify(data))
  },
  get(key) {
    const dataStr = localStorage.getItem(key)
    try {
      if (dataStr) {
        const data = JSON.parse(dataStr)
        return data && typeof data === 'object' ? data : dataStr
      } else {
        return dataStr
      }
    } catch (e) {
      return dataStr
    }
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  removeAll() {
    localStorage.clear()
  }
}

export const getToken = () => {
  return LocalStore.get(TOKEN_KEY)
}

export const setToken = (token) => {
  LocalStore.set(TOKEN_KEY, token)
}

export const removeToken = () => {
  LocalStore.remove(TOKEN_KEY)
}

export const setHtmlRemUnit = (() => {
    let timer = null;
    return (designWidth = 1920) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            const baseFontSize = 100;
            const screenWidth = window.innerWidth<1024?1024:window.innerWidth;
            const fontSize = (screenWidth / designWidth) * baseFontSize;
            document.documentElement.style.fontSize = `${fontSize}px`;
        }, 100);
    };
})();
 
//跳转处理
export function windowOpen(path,query){
    let queryV2 = query||{};
    queryV2.newPage = true;
    window.open(path + stringifyQuery(queryV2), '_blank');
}
/**
 * 判断数据类型是否为数字或数字字符串
 * @param {any} data - 待检查的数据
 * @returns {boolean} - 是否为数字或数字字符串
 */
export function isNumericData(data) {
  return (
    typeof data === 'number' ||
    (typeof data === 'string' && !isNaN(Number(data)))
  );
}
/*数字转亿万*/
export function numberObjFormat(data) {
  // 数据类型检查，确保data是一个数字
    if (typeof data !== 'number' && (typeof data !== 'string' || isNaN(Number(data)))
        ||(typeof data === 'string' && data.trim() === '')) {
      console.error(data,'Expected input to be a number')
      return {
        type:'',
        value: data
      };
    }
   const trillionUnit = ['','万', '亿', '兆', '京', '垓', '秭', '穰', '沟', '涧', '正', '载'];
    let unitIndex = 0;
    let resultNum = Math.abs(data);

    while (resultNum >= 10000) {
      resultNum /= 10000;
      unitIndex++;
    }

    if (resultNum < 1000) {
      // 保留两位小数，避免出现“一亿零”这样的情况
      resultNum = Number(resultNum.toFixed(2));
    } else {
      // 如果结果大于等于1000，无需保留小数
      resultNum = Math.floor(resultNum);
    }
    return {
      type:trillionUnit[unitIndex],
      value: data < 0? `-${resultNum}`: resultNum
    }

  // let valStr = "0",
  //   typeStr = "";
  // const initValue = String(Math.abs(data)).split(".")[0];
  // const strLength = initValue.length;
  // if (strLength >= 5 && strLength <= 8) {
  //   valStr = (data / 10000).toFixed(2);
  //   typeStr = "万";
  // } else if (strLength > 8) {
  //   valStr = (data / 100000000).toFixed(4);
  //   typeStr = "亿";
  // }else{
  //   valStr = String(data);
  // }
  // return {
  //   value: valStr,
  //   type: typeStr,
  // };
}

/*数字转亿万*/
export function numberFormat(data, unit) {
  let dataObj = numberObjFormat(data);
  return `<span class="num">${dataObj.value}</span><span>${dataObj.type}</span><span class="num_unit">${unit}</span>`;
}


/*数字转公里（带单位）*/
export function formatToKm(data) {
   if (data === null || data === undefined || data === '' || typeof data !== 'number' && (typeof data !== 'string' || isNaN(Number(data)))) {
    console.error(data, 'Expected input to be a number');
    return '-';
  }

  const num = Number(data);
  
  // if (num < 1000) {
  //   return `${Math.floor(num)} m`;
  // }
  
  const km = num / 1000;
  const kmStr = km;
  const result = Number(kmStr) === Math.floor(km) ? Math.floor(km) : kmStr;
  return `${result} km`;
}

/*纯数字转公里（不带单位）*/
export function numberToKm(data, keepDecimal = 2) {
  if (typeof data !== 'number' && (typeof data !== 'string' || isNaN(Number(data)))
      || (typeof data === 'string' && data.trim() === '')) {
    console.error(data, 'Expected input to be a number');
    return 0;
  }
  
  const km = Number(data) / 1000;
  const kmStr = km.toFixed(keepDecimal);
  return Number(kmStr) === Math.floor(km) ? Math.floor(km) : Number(kmStr);
}

/*时间戳转年月日时分秒*/
export function formatDateTime(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!timestamp) {
    return '-';
  }
  
  // let ts = Number(timestamp);
  // if (isNaN(ts)) {
  //   return '-';
  // }
  
  // if (ts < 1e12) {
  //   ts *= 1000;
  // }
  
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) {
    return '-';
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const second = String(date.getSeconds()).padStart(2, '0');
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hour)
    .replace('mm', minute)
    .replace('ss', second);
}
export function formatDateTime2(timestamp) {
  return timestamp ? `${formatDateTime(timestamp, 'YYYY-MM-DD')}<br/>${formatDateTime(timestamp, 'HH:mm:ss')}` : '-';
}
/*时间戳转日期（年月日）*/
export function formatDate(timestamp) {
  return formatDateTime(timestamp, 'YYYY-MM-DD');
}

export function getDateArray(beginTime, endTime) {
  const result = [];
  
  const parseDate = (dateStr) => {
    const [y, m, d] = dateStr.split('-').map(Number);
    if (isNaN(y) || isNaN(m) || isNaN(d)) {
      return null;
    }
    return new Date(y, m - 1, d);
  };
  
  const startDate = parseDate(beginTime);
  const endDate = parseDate(endTime);
  
  if (!startDate || !endDate) {
    return result;
  }
  
  const currentDate = new Date(startDate);
  
  while (currentDate <= endDate) {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    result.push(`${year}-${month}-${day}`);
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return result;
}

/*时间戳转时间（时分秒）*/
export function formatTime(timestamp) {
  return formatDateTime(timestamp, 'HH:mm:ss');
}
/**
 * 十六进制颜色值转为带透明度的颜色
 * @param _color 十六进制颜色
 * @param _opacity 透明度
 * @returns {string} rgba
 */
export function hexToRGBA(_color, _opacity) {
  var sColor = _color.toLowerCase();
  //十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值
    var sColorChange = [];
    for (var i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
    }
    return "rgba(" + sColorChange.join(",") + "," + _opacity + ")";
  }
  return sColor;
}

// 身份证-男女
export function getSexData(data) {
  let str = "";
  if (data.length === 15) {
    str = data.substr(13, 1);
  } else if (data.length === 18) {
    str = data.substr(16, 1);
  } else {
    return false;
  }
  if (Number(str) % 2 === 0) {
    return "女";
  } else {
    return "男";
  }
}
// 递归获取树的所有父级
export function getAllParentArr(arr, cid) {
  var treeData = [];
  function forIn(id) {
    arr.map((item) => {
      if (item.id === id) {
        treeData.unshift(item);
        if (item.pid) {
          forIn(item.pid);
        }
      }
    });
  }
  forIn(cid);
  return treeData;
}
 export const typeOf = d=> Object.prototype.toString.call(d).slice(8,-1).toLowerCase()
//深拷贝
export const deepCopy=data=> {
  var t = typeOf(data);
  var o = void 0;

  if (t === 'array') {
    o = [];
  } else if (t === 'object') {
    o = {};
  } else {
    return data;
  }

  if (t === 'array') {
    for (var i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]));
    }
  } else if (t === 'object') {
    for (var _i in data) {
      o[_i] = deepCopy(data[_i]);
    }
  }
  return o;
}
export const objectToFormData = (obj, form, namespace)=> {
  let fd = form || new FormData();
  let formKey;

  for (let property in obj) {
    if (obj.hasOwnProperty(property)) {
      formKey = namespace ? `${namespace}.${property}` : property;

      if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        objectToFormData(obj[property], fd, formKey);
      } else {
        fd.append(formKey, typeof obj[property] === 'undefined' ? '' : obj[property]);
      }
    }
  }

  return fd;
}
// 设置默认值的辅助函数
export const setDefaultValue = (item, key, defaultValue) => {
    // 判断item[key]是否存在并且如果是数组则判断其长度
    if (!item.hasOwnProperty(key) || item.hasOwnProperty(key)&&item[key]=='' || (Array.isArray(item[key]) && item[key].length === 0)) {
        item[key] = defaultValue;
    }
};

// 将树形数组摊平为一维数组
export const flattenTree = (tree, childrenKey = 'children') => {
    return tree.reduce((result, item) => {
        const { [childrenKey]: children, ...rest } = item;
        result.push(rest);
        if (children && children.length > 0) {
            result.push(...flattenTree(children, childrenKey));
        }
        return result;
    }, []);
};


// 树形数据转换函数：将任意树形结构转换为 el-tree-select 需要的格式
export const categoryTransformTreeData = (data, props = {}) => {  
  if (!data || !Array.isArray(data)) return [];
  
  return data.map(node => {
    const result = {
      label: node.name,
      value: node.data? node.data.categoryId : node.name,
      data: node.data
    };
    
    if (node.children && Array.isArray(node.children) && node.children.length > 0) {
      result.children = categoryTransformTreeData(node.children, props);
      result.isLeaf = false;
    } else {
      result.isLeaf = true;
    }
    
    return result;
  });
};




// 计算车龄
export const formatCarAge = (row) => {
  // 优先使用上路时间，其次使用发证时间
  const dateStr = row?.licenseIssueDate || row?.issueDate;
  if (!dateStr) return '-';
  
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '-';
  
  const now = new Date();
  let years = now.getFullYear() - date.getFullYear();
  let months = now.getMonth() - date.getMonth();
  let days = now.getDate() - date.getDate();
  
  if (days < 0) {
    months--;
    const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    days += prevMonth.getDate();
  }
  
  if (months < 0) {
    years--;
    months += 12;
  }
  
  if (years > 0) {
    if (months > 0) {
      return `${years}年${months}个月`;
    }
    return `${years}年`;
  }
  if (months > 0) {
    return `${months}个月`;
  }
  if (days > 0) {
    return `${days}天`;
  }
  return '不足1天';
};